<div class="flex w-full">
  <div class="w-full">
    <div class="max-[991px]:pt-6">
      <div class="flex items-center justify-between gap-6 border-b border-gray-300 pb-px">
        <div>
          <app-header title="AI Document Processor"
            subTitle="Advanced OCR and data extraction for enterprise documents"></app-header>
        </div>
        <div class="wallet-box d-flex align-items-center px-2 py-1 rounded"
            [ngbTooltip]="(credits ?? 0) === 0 ? 'Contact admin' : null"
            triggers="mouseenter:mouseleave" placement="bottom" container="body">
            <span class="wallet-icon me-1">💰</span>
            <span class="wallet-amount">Credits: {{ credits ?? 0 }} </span>
          </div>
      </div>
    </div>

    <!-- Category Selection Modal -->
    @if (showCategoryModal) {
    <div class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div class="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 animate-in fade-in zoom-in-95">
        <div class="mb-6">
          <h2 class="text-xl font-bold text-gray-900 mb-2">Select Document Category</h2>
          <p class="text-sm text-gray-600">Multiple categories found. Please select the category.</p>
        </div>

        <div class="space-y-2 mb-6 max-h-64 overflow-y-auto">
          @for (category of availableCategories; track category.id) {
          <button
            (click)="selectCategory(category.id)"
            class="w-full text-left px-3 py-2 rounded border border-gray-200 hover:border-orange-400 hover:bg-orange-50 transition-all duration-200 group text-sm">
            <div class="flex items-center gap-2">
              <div class="w-4 h-4 rounded border border-gray-300 group-hover:border-orange-600 flex items-center justify-center flex-shrink-0 mt-0.5">
                <div class="w-1.5 h-1.5 bg-orange-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <span class="font-medium text-gray-900 group-hover:text-orange-600 truncate">{{ category.name }}</span>
            </div>
          </button>
          }
        </div>

        <div class="flex gap-3">
          <button
            (click)="closeCategoryModal()"
            class="w-full px-3 py-1.5 rounded border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors">
            Cancel
          </button>
        </div>
      </div>
    </div>
    }

    <div class="overflow-visible px-2 sm:px-3 md:px-4 pb-3 pt-3">

      <!-- Upload Section (Always Visible) -->
      @if (!isProcessed && !isLoading) {
      <div class="flex flex-col gap-2 mb-6 w-full">
        <!-- Category Selection and File Upload -->
        <div class="border border-gray-200 rounded-xl p-6 bg-gradient-to-br from-white to-gray-50 shadow-sm hover:shadow-md transition-shadow">
          <div class="grid grid-cols-1 gap-6">
            <!-- Category Dropdown - COMMENTED OUT FOR FUTURE USE
            <div class="flex flex-col gap-3">
              <label class="text-sm font-semibold text-gray-700">Select Category</label>
              <app-dropdown 
                placeholder="Choose a category" 
                [options]="categoryOptions"
                [control]="categoryControl"
                (change)="onCategoryChange(categoryControl.value)">
              </app-dropdown>
            </div>
            -->

            <!-- File Upload -->
            <div class="flex flex-col gap-3">
              <label class="text-sm font-semibold text-gray-700">Upload Document</label>

              <!-- File Input (Hidden) - PDF and images -->
              <input #fileInput type="file" class="hidden" (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png,.webp">

              @if (!selectedFileName) {
              <!-- Upload Area -->
              <div
                class="border-2 border-dashed border-orange-300 rounded-lg p-8 text-center bg-gradient-to-br from-orange-50 to-orange-25 cursor-pointer transition-all hover:border-orange-400 hover:shadow-md"
                [ngClass]="isDragOver ? 'border-orange-500 bg-orange-100 shadow-lg' : ''" 
                (click)="triggerFileInputClick()"
                (dragover)="onDragOver($event)" 
                (dragleave)="onDragLeave($event)" 
                (drop)="onDrop($event)">
                <div class="flex flex-col items-center gap-3">
                  <div class="w-14 h-14 bg-white rounded-lg flex items-center justify-center shadow-sm border border-orange-100">
                    <svg class="w-7 h-7 text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
                    </svg>
                  </div>
                  <div>
                    <p class="text-sm font-semibold text-gray-800">Drag & drop your document</p>
                    <p class="text-sm font-light text-grat-800">or click to browse • PDF or images</p>
                  </div>
                </div>
              </div>
              } @else {
              <!-- Selected File Display -->
              <div
                class="border-2 border-solid border-orange-300 rounded-lg p-4 bg-gradient-to-r from-orange-50 to-orange-25 flex items-center justify-between cursor-pointer transition-all hover:shadow-md"
                (click)="triggerFileInputClick()">
                <div class="flex items-center gap-3 flex-1">
                  <div class="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm border border-orange-100">
                    <svg class="w-6 h-6 text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
                    </svg>
                  </div>
                  <div class="min-w-0">
                    <p class="text-sm font-semibold text-gray-800 truncate">{{ selectedFileName }}</p>
                    <p class="text-xs text-gray-500">Click to change file</p>
                  </div>
                </div>
                <div class="flex-shrink-0 ml-2">
                  <svg class="w-5 h-5 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
              }
            </div>
          </div>

          <!-- Process Button -->
          <div class="flex justify-end mt-6 pt-4 border-t border-gray-200">
            <app-common-button [type]="'button'" (clickEvent)="onProcess()"
              [disabled]="!selectedFileName || isLoading" [buttonClass]="'mediumFilledbutton'"
              [leftIcon]="faMagicWandSparkles" [buttonLabel]="'Process Document'"
              [loadingIcon]="isLoading">
            </app-common-button>
          </div>
        </div>
      </div>
      }

      <!-- Results Section (Side by Side) -->
      @if (isProcessed || isLoading) {
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-4">

        <!-- Left: Document Preview -->
        <div class="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-white">
          @if (pdfUrl) {
          <div class="bg-gradient-to-r from-gray-50 to-white border-b border-gray-200 px-4 py-3 flex items-center justify-between overflow-x-auto">
            <span class="text-xs font-semibold text-gray-700 truncate">📄 {{ selectedFileName }}</span>
            <div class="flex items-center gap-2 flex-shrink-0">
              <button (click)="onDiscard()" class="p-2 hover:bg-gray-100 rounded-lg transition-colors" title="Close">
                <svg class="w-5 h-5 text-gray-500 hover:text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          </div>
          <div class="bg-gray-50 p-4 flex items-center justify-center">
            <div class="w-full bg-white rounded-lg shadow-sm overflow-visible border border-gray-200">
              <iframe [src]="pdfUrl | safeUrl" class="w-full border-none" style="height: auto; min-height: 600px;"
                title="Document Preview"></iframe>
            </div>
          </div>
          } @else {
          <div class="bg-gradient-to-br from-gray-50 to-gray-100 p-8 flex items-center justify-center min-h-[300px] md:min-h-[500px]">
            <div class="text-center text-gray-400">
              <svg class="w-16 h-16 mx-auto mb-4 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                </path>
              </svg>
              <p class="text-sm font-medium text-gray-500">No document uploaded yet</p>
              <p class="text-xs text-gray-400 mt-1">Upload a document to see preview</p>
            </div>
          </div>
          }
        </div>

        <!-- Right: OCR Results with Tabs -->
        <div class="rounded-xl overflow-hidden shadow-lg border border-gray-200 flex flex-col relative bg-white">
          <!-- Loading Overlay with SDEX Badge -->
          @if (isLoading) {
          <div
            class="absolute inset-0 z-50 bg-white/95 backdrop-blur-sm flex flex-col items-center justify-center p-8 text-center rounded-xl">
            <div class="mb-4">
              <div class="w-16 h-16 bg-contain bg-no-repeat animate-spin-slow"
                [ngStyle]="{ 'background-image': 'url(assets/Images/login/headerLogo.svg)' }">
              </div>
            </div>
            <p class="text-sm font-semibold text-gray-700">Processing document...</p>
            <p class="text-xs text-gray-500 mt-2">This may take a few moments</p>
          </div>
          }

          <!-- Tabs -->
          <div class="bg-gradient-to-r from-white to-gray-50 border-b border-gray-200 px-3 py-2 flex gap-1 overflow-x-auto">
            <button (click)="setTab('OCR Text')" [class.bg-orange-50]="activeTab === 'OCR Text'"
              [class.text-orange-600]="activeTab === 'OCR Text'" [class.text-gray-600]="activeTab !== 'OCR Text'"
              [class.border-b-2]="activeTab === 'OCR Text'" [class.border-orange-600]="activeTab === 'OCR Text'"
              class="px-3 py-2 text-xs font-medium whitespace-nowrap rounded-t transition-all duration-200 border-b-2 border-transparent">
              📝 OCR Text
            </button>
            <button (click)="setTab('Raw JSON')" [class.bg-orange-50]="activeTab === 'Raw JSON'"
              [class.text-orange-600]="activeTab === 'Raw JSON'" [class.text-gray-600]="activeTab !== 'Raw JSON'"
              [class.border-b-2]="activeTab === 'Raw JSON'" [class.border-orange-600]="activeTab === 'Raw JSON'"
              class="px-3 py-2 text-xs font-medium whitespace-nowrap rounded-t transition-all duration-200 border-b-2 border-transparent">
              {{ '{' }}{{ '}' }} Raw JSON
            </button>
            <button (click)="setTab('Formatted')" [class.bg-orange-50]="activeTab === 'Formatted'"
              [class.text-orange-600]="activeTab === 'Formatted'" [class.text-gray-600]="activeTab !== 'Formatted'"
              [class.border-b-2]="activeTab === 'Formatted'" [class.border-orange-600]="activeTab === 'Formatted'"
              class="px-3 py-2 text-xs font-medium whitespace-nowrap rounded-t transition-all duration-200 border-b-2 border-transparent">
              ✨ Formatted
            </button>
            @if (metadata?.categoryDetails) {
            <button (click)="setTab('Category Details')" [class.bg-orange-50]="activeTab === 'Category Details'"
              [class.text-orange-600]="activeTab === 'Category Details'" [class.text-gray-600]="activeTab !== 'Category Details'"
              [class.border-b-2]="activeTab === 'Category Details'" [class.border-orange-600]="activeTab === 'Category Details'"
              class="px-3 py-2 text-xs font-medium whitespace-nowrap rounded-t transition-all duration-200 border-b-2 border-transparent">
              Metadata
            </button>
            }

          </div>

          <!-- Tab Content -->
          <div class="bg-white p-6 overflow-auto flex-1 min-h-[300px] md:min-h-[500px]">
            @if (isProcessed) {
            <div class="font-mono text-sm text-gray-700">
              @if (activeTab === 'OCR Text') {
              <pre class="whitespace-pre-wrap text-gray-600 leading-relaxed break-words">{{ ocrText }}</pre>
              } @else if (activeTab === 'Raw JSON') {
              <pre class="text-orange-600 leading-relaxed">{{ rawJson | json }}</pre>
              } @else if (activeTab === 'Formatted') {
              <div class="space-y-3 sm:space-y-4">
                @for (data of stracturedData; track $index) {
                <div class="pb-3 sm:pb-4 border-b border-gray-200 last:border-none">
                  <h3 class="text-xs sm:text-sm font-semibold text-gray-800 mb-2 sm:mb-3 flex items-center gap-2">
                    <span class="w-2 h-2 bg-orange-600 rounded-full"></span>
                    {{ formatText(data.key) }}
                  </h3>

                  @if (data?.value) {
                  <p class="text-xs sm:text-sm text-gray-600 pl-3 sm:pl-4 mb-2 sm:mb-3">{{ data.value }}</p>
                  }

                  @if (data?.childs?.length) {
                  <div class="space-y-1 sm:space-y-2 pl-3 sm:pl-4 border-l-2 border-orange-200 mb-2 sm:mb-3">
                    @for (child of data.childs; track $index) {
                    <div class="text-xs sm:text-sm text-gray-600">
                      @if (child?.childs?.length) {
                        <strong class="text-gray-700 block mb-1">{{ formatText(child.key) }}</strong>
                        <div class="space-y-1 pl-2 sm:pl-3 border-l border-orange-100">
                          @for (sub of child.childs; track $index) {
                          <div><strong class="text-gray-600">{{ formatText(sub.key) }}:</strong> {{ sub.value }}</div>
                          }
                        </div>
                      } @else {
                        <strong class="text-gray-700">{{ formatText(child.key) }}:</strong>
                        <span> {{ child?.value }}</span>
                      }
                    </div>
                    }
                  </div>
                  }

                  @if (data?.table?.type === 'Table') {
                  <div class="overflow-x-auto pl-3 sm:pl-4 mt-2">
                    <table class="min-w-full text-xs border border-gray-200 rounded">
                      <thead class="bg-orange-50">
                        <tr>
                          @for (col of data.table.keys; track $index) {
                          <th class="px-2 sm:px-3 py-2 text-left font-semibold text-gray-700 border-b border-gray-200">{{ col }}</th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of data.table.values; track $index) {
                        <tr class="even:bg-gray-50">
                          @for (cell of row; track $index) {
                          <td class="px-2 sm:px-3 py-2 text-gray-600 border-b border-gray-100">{{ cell }}</td>
                          }
                        </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  }
                </div>
                }
              </div>
              } @else if (activeTab === 'Category Details') {
              @if (metadata?.categoryDetails) {
              <div class="space-y-4">
                <!-- Category name -->
                <div class="pb-3 border-b border-gray-200">
                  <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Category</p>
                  <p class="text-sm font-semibold text-gray-800">{{ metadata.categoryDetails.category }}</p>
                </div>

                <!-- Keywords -->
                @if (metadata.categoryDetails.keywords?.length) {
                <div>
                  <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Keywords</p>
                  <div class="flex flex-wrap gap-2">
                    @for (kw of metadata.categoryDetails.keywords; track $index) {
                    <span class="text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 font-medium">{{ kw }}</span>
                    }
                  </div>
                </div>
                }

                <!-- Fields -->
                @if (metadata.categoryDetails.metadata?.length) {
                <div>
                  <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Fields</p>
                  <div class="space-y-2">
                    @for (field of metadata.categoryDetails.metadata; track $index) {
                    <div class="flex items-center justify-between py-2 px-3 bg-gray-50 rounded-lg border border-gray-200">
                      <span class="text-sm text-gray-700">{{ field.label }}</span>
                      <span class="text-xs px-2 py-0.5 rounded-full bg-orange-100 text-orange-700 font-medium">{{ field.fieldType }}</span>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              } @else {
              <div class="flex items-center justify-center h-full text-gray-400">
                <p class="text-sm">No category details available</p>
              </div>
              }
              }
            </div>
            } @else if (!isLoading) {
            <div class="flex items-center justify-center h-full text-gray-400">
              <p class="text-sm">No data extracted yet</p>
            </div>
            }
          </div>
        </div>

        
      </div>
      }

    </div>
  </div>
</div>

<app-error-toaster *ngIf="toasterMsg" [title]="toasterMsg" (closeToaster)="closeToaster()"></app-error-toaster>